import * as Sentry from '@sentry/react'

/**
 * Initialise Sentry error and performance monitoring.
 * No-op when VITE_SENTRY_DSN is absent (local dev, test environments).
 */
export function initialiseSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Session Replay — records screen captures on error
      Sentry.replayIntegration(),
    ],
    // Capture 10% of transactions for performance monitoring; adjust as traffic grows
    tracesSampleRate: 0.1,
    // Capture 10% of sessions for Session Replay
    replaysSessionSampleRate: 0.1,
    // Always capture the full session when an error occurs
    replaysOnErrorSampleRate: 1.0,
  })
}
